import Constants from "~/helpers/enums/Constants";

const tooglePageToolbar = (toogle) => (dispatch) => {
    dispatch({ type: Constants.TOOGLE_TOOLBAR, payload: toogle });
};

export default {
  tooglePageToolbar
};
